import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowRight, CheckCircle2, BrickWall, Hammer, Layers, PaintRoller, Wrench, Building2 } from "lucide-react";
import { usePageMeta } from "../hooks/usePageMeta";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { CTABand } from "../components/CTABand";
import { SERVICES } from "../data/site";
import { scrollToEl } from "../lib/smooth";

const ICONS = { BrickWall, Hammer, Layers, PaintRoller, Wrench, Building2 };

export default function Servizi() {
  usePageMeta(
    "Servizi Edili in Veneto | Opere Murarie, Ristrutturazioni, Cartongesso | Costruzioni Ciosko",
    "Opere murarie, ristrutturazioni, cartongesso, intonaci e finiture, manutenzione edile e interventi per aziende e cantieri in Veneto."
  );
  const { hash } = useLocation();
  useEffect(() => {
    if (hash) setTimeout(() => scrollToEl(hash), 150);
  }, [hash]);

  return (
    <>
      <PageHero
        overline="Servizi"
        lines={["Lavorazioni edili,", "dalla muratura alla finitura"]}
        description="Ogni intervento viene pianificato ed eseguito con metodo: sopralluogo, preventivo chiaro, cantiere organizzato e cura del dettaglio."
        image="/images/servizio-ristrutturazioni.jpg"
      />
      <section className="py-16 lg:py-24">
        <div className="max-w-7xl mx-auto px-5 lg:px-10 space-y-16 lg:space-y-24">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon];
            const flip = i % 2 === 1;
            return (
              <article key={s.slug} id={s.slug} data-testid={`servizio-dettaglio-${s.slug}`} className="scroll-mt-28 grid lg:grid-cols-2 gap-8 lg:gap-16 items-center">
                <Reveal className={flip ? "lg:order-2" : ""}>
                  <div className="steel-frame">
                    <div className="aspect-[16/11] overflow-hidden border border-steel">
                      <img src={s.img} alt={s.title} loading="lazy" className="w-full h-full object-cover hover:scale-105 transition-transform duration-[1.2s]" />
                    </div>
                  </div>
                </Reveal>
                <Reveal delay={0.12} className={flip ? "lg:order-1" : ""}>
                  <div className="flex items-center gap-4">
                    <span className="w-11 h-11 flex items-center justify-center border border-steel text-forest-glow" aria-hidden="true"><Icon size={19} /></span>
                    <span className="font-mono text-xs tracking-[0.25em] text-cement/70">{String(i + 1).padStart(2, "0")}</span>
                  </div>
                  <h2 className="h-display text-2xl sm:text-3xl mt-5 text-white">{s.title}</h2>
                  <p className="text-cement leading-relaxed mt-5 text-[15px] sm:text-base">{s.long}</p>
                  <ul className="mt-6 grid sm:grid-cols-2 gap-3">
                    {s.points.map((p, j) => (
                      <li key={j} className="flex items-start gap-2.5 text-sm text-metal/85">
                        <CheckCircle2 size={15} className="text-forest-glow shrink-0 mt-0.5" /> {p}
                      </li>
                    ))}
                  </ul>
                  <Link to="/contatti" data-testid={`servizio-quote-${s.slug}`} className="btn-primary mt-8">
                    Richiedi un preventivo <ArrowRight size={15} />
                  </Link>
                </Reveal>
              </article>
            );
          })}
        </div>
      </section>
      <CTABand />
    </>
  );
}
